import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SMART_GROUPS_TAG, SmartGroupsState } from './smart-groups.reducer';

const selectSmartGroupsState = createFeatureSelector<SmartGroupsState>(SMART_GROUPS_TAG);

export const selectData = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.data);
export const selectPages = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.pages);
export const selectCachedPages = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.cachedPages);
export const selectPagedData = createSelector(selectData, selectPages, (data, pages) => ({ ...data, pages }));
export const selectGridSearch = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.gridSearch);
export const selectStatus = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.status);
export const selectSort = createSelector(selectSmartGroupsState, (state: SmartGroupsState) => state.sort);
